// import BADMINTON from './imgs/BADMINTON.png';
// import TABLE_TENNIS from './imgs/TABLE_TENNIS.png';

const data = {
  id: 1,
  title: 'Listen and choose the picture described.',
  subTitle: 'Nghe và chọn hình ảnh được mô tả.',
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/3430eabf-50d2-4215-b571-2a6d50570651.mp3',
  question: '',
  answers: [
    { id: 1, answer: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/Starters/table%20tennis.png', isCorrect: false },
    { id: 2, answer: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/Starters/badminton.png', isCorrect: true },
  ],
  settings: {
    answers: {
      // direction: 'horizontal',
      // direction: 'vertical',
      bulletType: 'character',
      imageAnswers: true, // True là vẽ hình, False hoặc không có là vẽ Button.
      columnImageAnswers: 2, // Số cột và hình nên đi cặp cùng nhau.
    },
  },
};

export default data;
